import { Stack } from '@rossum/ui/material';
import { useState } from 'react';
import { operatorWrapperStyles } from '../../../document-list-base/components/FilterOperators';
import {
  doUnsavedValuesExist,
  getStringArrayValueWithDefault,
  isEmptyValue,
} from '../../../document-list-base/mql/helpers';
import { SimpleFilterComponentProps } from '../../../document-list-base/mql/types';
import { useWorkspacesWithQueues } from '../../../queues/hooks/useWorkspacesWithQueues';
import { QueueSelectList } from '../../../queues/select-queue/QueueSelectList';
import { useOperators } from '../../hooks/useOperators';
import { FilterActionsWrapper } from './FilterActionsWrapper';
import { SelectionHandlers } from './SelectionHandlers';

const convertToNumber = (value: string[]): number[] =>
  value.flatMap(val => Number(val) || []);

export const FilterQueueSelect = ({
  filterItem,
  applyFilter,
  onBackClick,
  onClose,
  convertToAdvancedFilter,
  isInAdvancedFilter,
}: SimpleFilterComponentProps) => {
  const { filterContext } = filterItem;

  const topSelections = getStringArrayValueWithDefault(filterContext.value);

  const [selectedQueues, setSelectedQueues] = useState<string[]>(topSelections);
  const { workspacesWithQueues: queuesByWorkspace, isLoading } =
    useWorkspacesWithQueues({
      enableQueries: true,
    });

  const queuesIds = queuesByWorkspace?.flatMap(w =>
    w.queues.map(queue => `${queue.id}`)
  );

  const handleOnClickOnMore = convertToAdvancedFilter
    ? () =>
        convertToAdvancedFilter(
          operator,
          doUnsavedValuesExist(selectedQueues, filterContext.value)
            ? selectedQueues
            : undefined
        )
    : undefined;

  const { node: Operators, operator } = useOperators({ filterItem });

  return (
    <FilterActionsWrapper
      onSubmit={() => {
        applyFilter({
          operator,
          value: selectedQueues,
        });
      }}
      onBackClick={onBackClick}
      isSubmitDisabled={isLoading || isEmptyValue(selectedQueues)}
      onCancel={onClose}
      onClickOnMore={handleOnClickOnMore}
      columnField={filterItem.column.field}
      disableOnMoreClick={isLoading}
    >
      <Stack sx={operatorWrapperStyles}>
        {!isInAdvancedFilter ? <Operators /> : null}
        {queuesIds && (
          <SelectionHandlers
            selectedValues={selectedQueues}
            valueOptions={queuesIds}
            setValues={setSelectedQueues}
          />
        )}
      </Stack>
      <Stack sx={{ width: '100%' }}>
        <QueueSelectList
          topSelections={convertToNumber(topSelections)}
          onSelect={ids => {
            setSelectedQueues(ids.map(id => id.toString()));
          }}
          selectedQueues={convertToNumber(selectedQueues)}
          searchInputProps={{ dataCy: 'queue-filter-component-search-input' }}
          queuesByWorkspace={queuesByWorkspace ?? []}
          isLoading={isLoading}
          multiSelect
          dense
        />
      </Stack>
    </FilterActionsWrapper>
  );
};
